import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminSalesContent from "../admin/components/AdminSalesContent";

const SupportManagerSales = () => {
  return (
    <SupportLayout userRole="SM">
      <AdminSalesContent useOwnLayout={true} />
    </SupportLayout>
  );
};

export default SupportManagerSales;
